import React, { useState } from 'react';
import './FirmDashboard.css';
import PostArticleship from './PostArticleship';
import FirmJobs from './FirmJobs';
import FirmProfile from './FirmProfile';

const FirmDashboard = ({ onLogout }) => {
    const [activeTab, setActiveTab] = useState('jobs');

    return (
        <div className="firm-dashboard">
            <div className="firm-dashboard-content">
                {activeTab === 'post' && <PostArticleship />}
                {activeTab === 'jobs' && <FirmJobs />}
                {activeTab === 'profile' && <FirmProfile onLogout={onLogout} />}
            </div>

            <div className="firm-dashboard-tabs">
                <button 
                    className={`firm-dashboard-tab ${activeTab === 'post' ? 'active' : ''}`}
                    onClick={() => setActiveTab('post')}
                >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="12" y1="5" x2="12" y2="19"></line>
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                    <span>Post</span>
                </button>
                <button 
                    className={`firm-dashboard-tab ${activeTab === 'jobs' ? 'active' : ''}`}
                    onClick={() => setActiveTab('jobs')}
                >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                    </svg>
                    <span>Articleship</span>
                </button>
                <button 
                    className={`firm-dashboard-tab ${activeTab === 'profile' ? 'active' : ''}`}
                    onClick={() => setActiveTab('profile')}
                >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                    <span>Profile</span>
                </button>
            </div>
        </div>
    );
};

export default FirmDashboard;
